import React from "react";
import { Button, Form, InputNumber } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

interface SpeedFormProps {
  style?: object;
  onFinish?: (t: object) => void;
  onReset?: (t: object) => void;
  form?: any;
}

const SpeedForm = ({ style, onFinish, onReset, form }: SpeedFormProps) => {
  const { t } = useTranslation();

  return (
    <Form
      name="speedForm"
      layout="vertical"
      style={style}
      onFinish={onFinish}
      onReset={onReset}
      form={form}
      initialValues={{ speedItems: [] }}
    >
      <Form.Item
        label={t("speedChart.speed.label")}
        rules={[
          {
            validator: async (_: any, names: any) => {
              if (!names || names.length < 2) {
                return Promise.reject(new Error(t("speedChart.speed.error2")));
              }
            },
          },
        ]}
      >
        <Form.List name="speedItems">
          {(fields, { add, remove }, { errors }) => (
            <>
              {fields.map((field, index) => (
                <Form.Item key={field.key}>
                  <Form.Item
                    {...field}
                    noStyle
                    rules={[
                      {
                        required: true,
                        message: t("speedChart.speed.error"),
                      },
                    ]}
                  >
                    <InputNumber
                      placeholder={t("speedChart.speed.placeholder")}
                      style={{ width: "90%" }}
                    />
                  </Form.Item>
                  <MinusCircleOutlined
                    style={{ width: "10%" }}
                    onClick={() => remove(field.name)}
                  />
                </Form.Item>
              ))}
              <Form.Item noStyle>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  icon={<PlusOutlined />}
                  style={{ width: "100%" }}
                >
                  {t("speedChart.speed.add")}
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          {t("speedChart.speed.submit")}
        </Button>
        <Button type="ghost" style={{ marginLeft: "10px" }} onClick={onReset}>
          {t("speedChart.speed.clear")}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default SpeedForm;
